(() => {
  const CHECKBOX_ID = 'terms-checkbox-cart';
  const CHECKOUT_ID = 'checkout';
  const FORM_ID = 'cart-form';

  // “見つけたら必ず”適用（checkboxが未チェック=必ず無効）
  function enforce() {
    const checkbox = document.getElementById(CHECKBOX_ID);
    const checkoutBtn = document.getElementById(CHECKOUT_ID);
    const form = document.getElementById(FORM_ID);

    // ドロワーが開いてない/まだDOMに無い時は何もしない
    if (!checkoutBtn || !form) return;

    // checkboxがまだ描画されてない瞬間もあるので、その場合は「安全側」で無効にする
    const checked = checkbox ? checkbox.checked : false;
    checkoutBtn.disabled = !checked;

    // 多重バインド防止（フォーム単位で1回だけ）
    if (form.dataset.termsGuardBound === '1') return;
    form.dataset.termsGuardBound = '1';

    // チェック変化で同期（checkboxが存在する場合のみ）
    if (checkbox) {
      checkbox.addEventListener('change', () => {
        checkoutBtn.disabled = !checkbox.checked;
      });
    }

    // submit 自体を止める（すり抜け防止）
    form.addEventListener(
      'submit',
      (e) => {
        // submitterが取れない/テーマが独自送信する場合もあるので「安全側」で止める
        const cb = document.getElementById(CHECKBOX_ID);
        const isCheckedNow = cb ? cb.checked : false;

        // checkout目的の送信のみ止めたいが、判定不能ケースがあるので
        // “チェックが無いなら checkout は絶対禁止”に寄せる（安全）
        const submitter = e.submitter;
        const looksLikeCheckout =
          !submitter || submitter.id === CHECKOUT_ID || submitter.name === 'checkout';

        if (looksLikeCheckout && !isCheckedNow) {
          e.preventDefault();
          e.stopPropagation();
          alert('利用規約に同意してください');
          (cb || checkoutBtn).focus();
        }
      },
      true
    );
  }

  document.addEventListener('DOMContentLoaded', enforce);

  // ドロワーは差し替えが頻繁なので監視して毎回 enforce
  const mo = new MutationObserver(() => enforce());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
